module.exports = __webpack_public_path__ + "static/media/arrow_left.bb6ee07a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/arrow_left.svg
 ** module id = 688
 ** module chunks = 0
 **/